<template>
  <div style="background-color: #F8F9FB;">
    <hhead></hhead>
    <div class="stateBox">
      <img src="../../../../assets/images/crm/state.png" alt="" />
      <p>您的申请已经发送成功，正在等待合作方管理员审核!</p>
      <router-link class="fh" to="/">返回首页</router-link>
      <span
        >当前合作方管理人为：{{
          res.regCustomerName
        }}，需要等待其审核才能加入合作方。</span
      >
    </div>
  </div>
</template>
<script>
import hhead from '../../header/index';
import './style.css';
export default {
  components: { hhead },
  data() {
    return {
      res: '',
    };
  },
  mounted() {
    this.$axios
      .post('/crm/ent/getAuthInfo', {
        apiToken: this.$store.state.usermsg.apiToken,
      })
      .then((res) => {
        // console.log(res);
        this.tokenInvalid(res);
        if (res.data.code == 401) {
          this.res = res.data.data;
        }
      });
  },

  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/view/crm/qyQuery/state/index.vue